import App from "../App";

// The sole Inertia page: a thin shell that mounts the existing SPA. The SPA owns
// all routing/state client-side (it reads local IndexedDB to decide onboarding vs.
// app), so no server props are rendered here — content stays end-to-end encrypted.
export default function Page() {
  return <App />;
}
